import { ApiClientInterface } from './clients';
import { HttpError } from './errors';
import {
  AccountStat,
  LenderStats,
  normalizeAccountStat,
  PackageProject,
  UrlResult,
} from './models';

export class StatsProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public getStats(): Promise<LenderStats> {
    return this.apiClient.get('/lender');
  }

  public async getAccountStat(accountUuid: string): Promise<AccountStat> {
    const data = await this.apiClient.get(`/account/${accountUuid}`);
    const stat = normalizeAccountStat(data);

    if (!stat) {
      throw new HttpError('Invalid account stat response');
    }

    return stat;
  }

  public getProjectsByPackage(packageUuid: string): Promise<PackageProject[]> {
    return this.apiClient.get(`/package/${packageUuid}/projects`);
  }

  public exportStatistics(): Promise<UrlResult> {
    return this.apiClient.get(`/export-statistics`);
  }
}
